import { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

export function FloatingChat({ chatUrl, enabled }) {
  const [isOpen, setIsOpen] = useState(false);

  if (!enabled || !chatUrl) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50" data-testid="floating-chat">
      {isOpen && (
        <div className="mb-3 bg-white rounded-2xl shadow-2xl border border-slate-200 p-4 w-72 animate-in slide-in-from-bottom-2" data-testid="chat-popup">
          <div className="flex items-center justify-between mb-3">
            <p className="font-semibold text-slate-900 text-sm">Chat with us</p>
            <button onClick={() => setIsOpen(false)} className="text-slate-400 hover:text-slate-600">
              <X className="w-4 h-4" />
            </button>
          </div>
          <p className="text-xs text-slate-500 mb-3">Have questions? Reach out to us directly.</p>
          <a
            href={chatUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full text-center bg-slate-900 text-white py-2.5 rounded-full text-sm font-medium hover:bg-slate-800 transition-colors"
            data-testid="chat-link"
          >
            Open Chat
          </a>
        </div>
      )}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-14 h-14 bg-slate-900 text-white rounded-full shadow-lg hover:bg-slate-800 transition-all flex items-center justify-center hover:scale-105"
        data-testid="chat-toggle-btn"
      >
        {isOpen ? <X className="w-6 h-6" /> : <MessageCircle className="w-6 h-6" />}
      </button>
    </div>
  );
}
